import MuiButton from '@mui/material/Button';

/**
 * @typedef  {import('@mui/material').ButtonProps} ButtonProps
 * @param {{underline?: boolean} & ButtonProps} props
 * */
export default function Button(props) {
    const { underline, sx, ...rest } = props;
    return (
        <MuiButton
            {...rest}
            sx={[
                underline && {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecoration: 'unset',
                    },
                },
                ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
            ]}
        />
    );
}
